import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, {
  type WorkspaceAgentElicitationComponentType,
  type WorkspaceAgentElicitationRequestedType,
  type WorkspaceAgentGuidedFlowEntry,
} from './useTrackAgentElicitationRequested.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type {
  WorkspaceAgentElicitationComponentType,
  WorkspaceAgentElicitationRequestedType,
  WorkspaceAgentGuidedFlowEntry,
} from './useTrackAgentElicitationRequested.meta';
export { WORKSPACE_AGENT_GUIDED_FLOW_ENTRIES } from './useTrackAgentElicitationRequested.meta';

type WorkspaceAgentElicitationRequestedSharedParams = {
  chat_id: string;
  elicitation_id: string;
  field_count?: number;
  has_escape_hatch: boolean;
  option_count?: number;
  step_index: number;
  tool_name?: string;
};

export type UseTrackAgentElicitationRequestedParams = WorkspaceAgentElicitationRequestedSharedParams &
  (
    | {
        component_type: 'guided_flow';
        elicitation_type: 'guided_flow';
        entry: WorkspaceAgentGuidedFlowEntry;
      }
    | {
        component_type: WorkspaceAgentElicitationComponentType;
        elicitation_type: Exclude<WorkspaceAgentElicitationRequestedType, 'guided_flow'>;
      }
  );

export const useTrackAgentElicitationRequested = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentElicitationRequested = useCallback(
    (params: UseTrackAgentElicitationRequestedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentElicitationRequested };
};
